import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ViewComponent implements OnInit {
  resourceId:any;
  resourceData:any
  imageUrl=environment.apiUrls.imageUrl;
  constructor(private apiService:ApiService,
    private activatedroute:ActivatedRoute) {
      this.activatedroute.paramMap.subscribe(params => { 
        this.resourceId = params.get('id'); 
        console.log('resourceId',this.resourceId)
       
    });
     }

  ngOnInit(): void {
    this.getResourceById()
  }
  getResourceById(){
    this.apiService.getResourceById(this.resourceId).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log('resourceData',res)
        this.resourceData =res.data 
      }
     

    })
  }
}
